import { useState } from "react";
import {
    getReportSettingDefaults,
    splitReportSettingValues,
} from "@common/helpers/report-settings/resolve-report-settings";
import { ReportSettingsConcreteReportKey } from "@common/types/reports/report-settings-report-key";
import { AccountingReportType } from "@common/types/reports/report-type";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { Picker } from "@design-system/Picker/Picker.lib";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import settingsStyles from "@components/settings/ReportSettings/ReportSettings.module.scss";
import { ReportPreview } from "@components/settings/ReportSettings/preview/ReportPreview";
import { PREVIEW_SAMPLE_ENTITY_NAME } from "@components/settings/ReportSettings/preview/reportPreviewData";
import { REPORT_SETTINGS_PREVIEW_OPTIONS } from "@components/settings/ReportSettings/reportTypeOptions";
import styles from "./ReportTemplatePreview.module.scss";

export const ReportTemplatePreviewBody = () => {
    const [reportKey, setReportKey] = useState<ReportSettingsConcreteReportKey>(
        AccountingReportType.PROFIT_LOSS,
    );
    const firm = useActiveOrganization();
    const { layout, numberFormat } = splitReportSettingValues(
        getReportSettingDefaults(reportKey),
    );

    return (
        <VStack gap={16} padding={24} align="center" className={styles.body}>
            <HStack gap={4} align="center">
                <span className={settingsStyles.previewPickerLabel}>
                    Preview
                </span>
                <Picker.Select
                    items={REPORT_SETTINGS_PREVIEW_OPTIONS}
                    searchable
                    value={reportKey}
                    onValueChange={(value) => {
                        if (value !== null) {
                            setReportKey(value);
                        }
                    }}
                    trigger={<Picker.Button variant="primary" size="md" />}
                />
            </HStack>
            <div className={styles.paper}>
                <ReportPreview
                    layout={layout}
                    numberFormat={numberFormat}
                    reportType={reportKey}
                    entityName={PREVIEW_SAMPLE_ENTITY_NAME}
                    firmName={firm?.name ?? null}
                    firmLogoUrl={firm?.logoUrl ?? null}
                    entityLogoUrl={null}
                />
            </div>
        </VStack>
    );
};
